export default __webpack_public_path__ + "static/Minimum-Viable-Product-a5b56e08e581a128634a573ebf97cc39.webp";